import React, { Component } from "react";
import * as Constants from "../../../common/Global/constants";
import { TableRadioButton, DialogSaveButton } from "../../../common/Global/globalStyles.style";
import { getLocalStorageVariables, isEmptyVariable, isEmptyArray, handleTokenExpiry } from "../../../common/Global/commonFunctions";
import { Modal } from "react-bootstrap";
import AlertDialog from "../../../common/AlertDialog";

let userDetails = getLocalStorageVariables();

class SelectGroupRiskDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedRiskId: "",
            riskErr: "",
            selectedLikelihoodId: "",
            likelihoodRiskErr: "",
            showAlertDialogInfo: false,
            alertDialogMessageInfo: ""
        };
        userDetails = getLocalStorageVariables();
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.showRiskDialog && this.props.showRiskDialog) {
            this.setState({
                selectedRiskId: isEmptyVariable(this.props.riskDetails?.riskLevelId) ? "" : this.props.riskDetails.riskLevelId + "",
                riskErr: "",
                selectedLikelihoodId: isEmptyVariable(this.props.riskDetails?.likelihoodLevelId) ? "" : this.props.riskDetails.likelihoodLevelId + "",
                likelihoodRiskErr: ""
            });
        }
    }

    handleAlertDialogCloseInfo = () => {
        this.setState({
            showAlertDialogInfo: false,
            alertDialogMessageInfo: ""
        });
    }

    handleSelection = (riskLevelId) => {
        this.setState({ selectedRiskId: riskLevelId, riskErr: "" });
    };

    handleSelectionLikelihood = (riskLevelId) => {
        this.setState({ selectedLikelihoodId: riskLevelId, likelihoodRiskErr: "" });
    };

    showLikelihood = () => {
        return this.props.isLikelihood && !isEmptyVariable(this.props.assignmentLikelihoodId);
    };

    returnSelectedRiskId = () => {
        let riskErrTemp = isEmptyVariable(this.state.selectedRiskId) ? "Select the risk level" : "";
        let likelihoodRiskErrTemp = (this.showLikelihood() && isEmptyVariable(this.state.selectedLikelihoodId)) ? "Select the likelihood level" : "";

        if (riskErrTemp || likelihoodRiskErrTemp) {
            this.setState({
                riskErr: riskErrTemp,
                likelihoodRiskErr: likelihoodRiskErrTemp
            });
            setTimeout(
                function () {
                    this.setState({ riskErr: "", likelihoodRiskErr: "" });
                }.bind(this),
                Constants.WRNG_MSG_TIMEOUT
            );
            return;
        }

        this.assignRiskToProcessFunction();
    };

    /*****************************API CALL*********************************/
    assignRiskToProcessFunction = () => {
        fetch(Constants.AssignRiskToProcessFunctionLevel, {
            method: "POST",
            mode: "cors",
            body: new URLSearchParams({
                email: userDetails.email,
                accessToken: userDetails.accessToken,
                processId: this.props.processId ?? "",
                functionId: this.props.functionId ?? "",
                assignmentId: this.props.assignmentId,
                riskLevelId: this.state.selectedRiskId,
                likelihoodLevelId: this.state.selectedLikelihoodId,
            }),
        })
        .then(response => response.json())
        .then(data => {
            if (handleTokenExpiry(data.responseCode)) return;
            if (data.responseCode === Constants.CODE_SUCCESS) {
                this.props.handleSelectRiskDialogClose(true);
            } else {
                this.setState({
                    showAlertDialogInfo: true,
                    alertDialogMessageInfo: data.responseMessage
                });
            }
        });
    }
    /*****************************API CALL END HERE*********************************/

    render() {
        return (
            <section>
                <Modal className="custom-dialog" show={this.props.showRiskDialog}
                    size={this.showLikelihood() ? "lg" : "md"} backdrop="static">
                    <Modal.Header>
                        <h5>Risk Level</h5>
                        <button onClick={this.props.handleSelectRiskDialogClose} type="button" data-dismiss="modal">
                            <span className="material-icons">close</span>
                        </button>
                    </Modal.Header>
                    <hr />
                    <div className="modal-body">
                        <div className="body-wrapper">
                            <div className="row">
                                <div className={this.showLikelihood() ? "col-md-6" : "col-md-12"}>
                                    {isEmptyArray(this.props.riskArr) ? (
                                        <div className="no-items-layout">
                                            <div className="no-items-card">
                                                <h6>No risk levels found</h6>
                                            </div>
                                        </div>
                                    ) : (
                                        <div>
                                            <div className="common-tab-bg">
                                                <div className="common-table" style={{ width: "100%", border: "1px solid #e5e5e5" }}>
                                                    <table className="table">
                                                        <thead>
                                                            <tr>
                                                                <th className="text-center" width={"8%"}></th>
                                                                <th>Risk Level</th>
                                                                <th>Color Code</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {this.props.riskArr.map((item) => {
                                                                return (
                                                                    <tr key={item.riskLevelId}>
                                                                        <td>
                                                                            <TableRadioButton themeSettings={this.props.themeSettings}>
                                                                                <input
                                                                                    type="checkbox"
                                                                                    name={item.riskLevelId}
                                                                                    id={"groupRisk_" + item.riskLevelId}
                                                                                    onChange={this.handleSelection.bind(this, item.riskLevelId)}
                                                                                    checked={item.riskLevelId + "" === this.state.selectedRiskId + ""}
                                                                                    disabled={this.props.allowEdit === "N"}
                                                                                />
                                                                                <label for={"groupRisk_" + item.riskLevelId} style={{ marginLeft: 6 }}></label>
                                                                            </TableRadioButton>
                                                                        </td>
                                                                        <td>{item.riskLevel}</td>
                                                                        <td>
                                                                            <div className="risk-level-color-wrapper" style={{ width: "38px" }}>
                                                                                <div className="risk-level-color" style={{ background: item.colorCode }} />
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                );
                                                            })}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                            {!isEmptyVariable(this.state.riskErr) && <span className="cm-error">{this.state.riskErr}</span>}
                                        </div>
                                    )}
                                </div>
                                {this.showLikelihood() &&
                                    <div className="col-md-6">
                                        <div>
                                            <div className="common-tab-bg">
                                                <div className="common-table" style={{ width: "100%", border: "1px solid #e5e5e5" }}>
                                                    <table className="table">
                                                        <thead>
                                                            <tr>
                                                                <th className="text-center" width={"8%"}></th>
                                                                <th>Likelihood Level</th>
                                                                <th>Color Code</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {(this.props.likelihoodRiskMatrix ?? []).map((item) => {
                                                                return (
                                                                    <tr key={item.riskLevelId}>
                                                                        <td>
                                                                            <TableRadioButton themeSettings={this.props.themeSettings}>
                                                                                <input
                                                                                    type="checkbox"
                                                                                    name={"likelihood_" + item.riskLevelId}
                                                                                    id={"groupLikelihood_" + item.riskLevelId}
                                                                                    onChange={this.handleSelectionLikelihood.bind(this, item.riskLevelId)}
                                                                                    checked={item.riskLevelId + "" === this.state.selectedLikelihoodId + ""}
                                                                                    disabled={this.props.allowEdit === "N"}
                                                                                />
                                                                                <label for={"groupLikelihood_" + item.riskLevelId} style={{ marginLeft: 6 }}></label>
                                                                            </TableRadioButton>
                                                                        </td>
                                                                        <td>{item.riskLevel}</td>
                                                                        <td>
                                                                            <div className="risk-level-color-wrapper" style={{ width: "38px" }}>
                                                                                <div className="risk-level-color" style={{ background: item.colorCode }} />
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                );
                                                            })}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                            {!isEmptyVariable(this.state.likelihoodRiskErr) && <span className="cm-error">{this.state.likelihoodRiskErr}</span>}
                                        </div>
                                    </div>
                                }
                            </div>
                            <div className="modal-close-save m-t-15">
                                <div className="close-save-col">
                                    <button onClick={this.props.handleSelectRiskDialogClose} type="button" className="modal-close m-b-0">
                                        {this.props.allowEdit === "N" ? "Close" : "Cancel"}
                                    </button>
                                    {this.props.allowEdit !== "N" &&
                                        <DialogSaveButton
                                            themeSettings={this.props.themeSettings}
                                            onClick={this.returnSelectedRiskId}
                                            type="button"
                                            className="modal-save m-b-0"
                                        >
                                            Save
                                        </DialogSaveButton>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>
                <AlertDialog
                    showAlertDialog={this.state.showAlertDialogInfo}
                    handleAlertDialogClose={this.handleAlertDialogCloseInfo}
                    type={Constants.ALERT_TYPE_ALERT}
                    alertDialogMessage={this.state.alertDialogMessageInfo}
                    proceedBtnClick={this.handleAlertDialogCloseInfo}
                    proceedBtnLabel={Constants.ALERT_TYPE_OKAY_LABEL}
                    themeSettings={this.props.themeSettings}
                />
            </section>
        );
    }
}

export default SelectGroupRiskDialog;
